import styled from "styled-components";

const Container = styled.div`
  @media screen {
    margin-top: 5px;
    /* 
      can't use mandatory here, because of days with entries that run off screen
      it would become impossible to add entries
    */
    scroll-snap-type: y proximity;

    padding: 0.5rem;
    padding-top: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      scroll-snap-type: y mandatory;
    }

    > div.day {
      padding: 0.5rem 00;
      background: white;
      display: flex;
      flex-direction: column;
      scroll-margin-block-start: 35px;
      scroll-snap-align: start;
      scroll-snap-stop: normal;

      transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);

      margin-bottom: ${({ theme }) => theme.spacing.md};

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: ${({ theme }) => theme.spacing.lg};

        padding: 1rem 0;
      }

      &:last-child {
        margin-bottom: 80vh;
      }
    }
    .day.selected {
      /*box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16), 0 1px 6px 1px rgba(0, 0, 0, 0.23);*/
    }
  }
`;

export default { Container };
